<template>
	<!-- Navbar start -->
	<navbar-element></navbar-element>
	<!-- Navbar end -->

	<!-- Rendered view start -->
	<home-view></home-view>
	<!-- Rendered view end -->

	<!-- Footer start -->
	<footer-element></footer-element>
	<!-- Footer end -->
</template>

<script>
import NavbarElement from '@/components/NavbarElement.vue';
import FooterElement from '@/components/FooterElement.vue';
import HomeView from '@/HomeView.vue';

export default {
	components: {
		HomeView,
		FooterElement,
		NavbarElement
	},
	mounted() {
		const usersLanguage = window.navigator.language
		const availibleLocales = this.$i18n.availableLocales;
		console.log("availibleLocales: ", availibleLocales)
		console.log("usersLanguage: ", usersLanguage);

		if (availibleLocales.includes(usersLanguage)) {
			this.$i18n.locale = usersLanguage;
		} else {
			this.$i18n.locale = 'en';
		}
	}
}
</script>

<style>

</style>
